import * as React from 'react';
import Status from 'design-system/Status';
import useColors from 'hooks/useColors';
import { isConnectionBroken, statusStrings } from '../utils';
const BankConnectionStatus = ({ data }) => {
    const colors = useColors();
    if (data.deactivatedOverQuota) {
        return (<Status inActiveColor={colors.elements.statusOffline} activeText={statusStrings.statusNotSyncing} inactiveText={statusStrings.statusNotSyncing} active={false}/>);
    }
    if (data.isClosed) {
        return (<Status inActiveColor={colors.elements.statusOffline} activeText={statusStrings.statusNotSyncing} inactiveText={statusStrings.statusNotSyncing} active={false}/>);
    }
    const syncStatus = data.bankInfo.status?.syncStatus;
    if (isConnectionBroken(data)) {
        return (<Status activeText={statusStrings.statusNeedsFix} inactiveText={statusStrings.statusNeedsFix} active={false}/>);
    }
    if (data.isSyncingManual) {
        return (<Status inActiveColor={colors.elements.statusInformational} activeText={statusStrings.statusSyncing} inactiveText={statusStrings.statusSyncing} active={false}/>);
    }
    if (syncStatus === 'DEGRADED') {
        return (<Status inActiveColor={colors.elements.statusInformational} activeText={statusStrings.statusDegraded} inactiveText={statusStrings.statusDegraded} active={false}/>);
    }
    if (syncStatus === 'DOWN') {
        return (<Status inActiveColor={colors.elements.statusOffline} activeText={statusStrings.statusDown} inactiveText={statusStrings.statusDown} active={false}/>);
    }
    return <Status activeText={statusStrings.statusWorking} inactiveText={statusStrings.statusWorking} active/>;
};
export default BankConnectionStatus;
